import { render, staticRenderFns } from "./sum-radar-chart.vue?vue&type=template&id=08641ef0&scoped=true&"
import script from "./sum-radar-chart.vue?vue&type=script&lang=js&"
export * from "./sum-radar-chart.vue?vue&type=script&lang=js&"
import style0 from "./sum-radar-chart.vue?vue&type=style&index=0&id=08641ef0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08641ef0",
  null
  
)

export default component.exports